var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n    background-image: url(" + escape(require("./final.png")) + ");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    background-attachment: fixed;\n}\n\nhtml, body {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n\n.title {\n    font-family: 'Courier New', Courier, monospace; /* Changed the font-family to a monospace font */\n}\n\n.content {\n    font-family: 'Courier New', Courier, monospace; /* Changed the font-family to a monospace font */\n\n}\n", ""]);

// exports
